module.exports = __webpack_public_path__ + "img/TechWheelbarrow1_ua.beb26efb.webp";